import { useState, useEffect } from "react";

export const useParallax = (speed = 0.5) => {
	const [offset, setOffset] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const scrolled = window.pageYOffset;
			setOffset(scrolled * speed);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [speed]);

	return offset;
};
